module.exports = __webpack_public_path__ + "img/language.1d63d91d.svg";